import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import DigitalSigningPageTextField from "./DigitalSigningPageTextField";
import {SETTINGS_ROWS_GAP} from "./DigitalSigningSettingsSection";
import {PageTexts, TipSettingsForm} from "./digitalSigningTemplate.util";

type TipTexts = Pick<TipSettingsForm, 'labels' | 'descriptions'>;

interface Props {
    value: TipTexts
    onChange: (value: TipTexts) => void
    errors?: {tipLabels?: Partial<PageTexts>, tipDescriptions?: Partial<PageTexts>}
    disabled?: boolean
}

/** Tip heading label and description fields for each supported page language. */
const DigitalSigningTipTextFields = ({value, onChange, errors, disabled}: Props) => {
    const {t} = useTranslation();

    return (
        <Stack gap={SETTINGS_ROWS_GAP}>
            <DigitalSigningPageTextField
                id={'digital-signing-tip-label'}
                title={t('Name')}
                tooltip={t('The tip\'s heading on the page, always followed by “· optional”. Empty: “Tip”.')}
                value={value.labels}
                onChange={labels => onChange({...value, labels})}
                errors={errors?.tipLabels}
                disabled={disabled}
            />
            <DigitalSigningPageTextField
                id={'digital-signing-tip-description'}
                title={t('Description')}
                tooltip={t('A line under the tip\'s heading, e.g. “Your whole tip goes to our team.” Empty: not shown.')}
                value={value.descriptions}
                onChange={descriptions => onChange({...value, descriptions})}
                errors={errors?.tipDescriptions}
                multiline
                disabled={disabled}
            />
        </Stack>
    );
};

export default DigitalSigningTipTextFields;
